import React, { useEffect } from 'react';
import { Card, Form } from 'antd';
import Layout from './layout';
import StudentFormItem from './StudentFormItem';
import InputTextArea from './InputTextArea';
import SubmitFormItem from './SubmitFormItem';
import ShowUserDetail from './ShowUserDetail';
import EnrollCourseFormItem from './EnrollCourseFormItem';
import TeacherFormItem from './TeacherFormItem';
import DateFormItem from './DateFormItem';
import CourseTypeSingleFormItem from './CourseTypeSingleFormItem';
import dataTransform from '../../../util/dataTransform';
import LocalStorageService from '../../../services/localStorageService';

const text = {
  cardTitle: '\u8bf7\u767b\u8bb0\u5b66\u751f\u4e0a\u8bfe\u7684\u5185\u5bb9',
  balance: '\u5b66\u751f\u4f59\u6b3e',
  content: '\u4e0a\u8bfe\u5185\u5bb9',
  contentPlaceholder: '\u8bf7\u8f93\u5165\u4e0a\u8bfe\u5185\u5bb9',
  contentRequired: '\u4e0a\u8bfe\u5185\u5bb9\u4e0d\u80fd\u4e3a\u7a7a',
  leavePage: '\u79bb\u5f00\u9875\u9762',
};

const Feedback = (props) => {
  const [form] = Form.useForm();
  const isTeacher = LocalStorageService.getCurrentRole() === 2;
  const currentTeacherId = LocalStorageService.getCurrentUserId();
  const {
    fetchStudentList,
    studentList,
    fetchEnrollCourseList,
    enrollCourseList,
    fetchEnrollCourseDetail,
    enrollCourseDetail,
    fetchTeacherList,
    teacherList,
    postFeedback,
    fetchOneStudentFeedbackList,
    feedbackDataSource,
    searchDetail,
  } = props;

  useEffect(() => {
    if (form.getFieldValue().enrollment) {
      fetchOneStudentFeedbackList(form.getFieldValue().enrollment);
    }
    return () => {
      console.log(text.leavePage);
      feedbackDataSource([]);
      searchDetail({});
    };
  }, [form.getFieldValue().enrollment]);

  useEffect(() => {
    if (isTeacher && currentTeacherId) {
      form.setFieldsValue({ teacher: currentTeacherId });
    }
  }, [currentTeacherId, form, isTeacher]);

  const handleSubmit = () => {
    console.log('raw feedback data: ', form.getFieldValue());
    const feedbackData = dataTransform.feedbackDataTransform(
      form.getFieldValue()
    );
    console.log('feedbackData: ', feedbackData);
    postFeedback(feedbackData);
    feedbackDataSource([]);
    form.resetFields();
    if (isTeacher && currentTeacherId) {
      form.setFieldsValue({ teacher: currentTeacherId });
    }
  };

  return (
    <div>
      <Card title={text.cardTitle}>
        <Form layout='horizontal' form={form}>
          <StudentFormItem
            rules={[]}
            form={form}
            fetchStudentList={fetchStudentList}
            studentList={studentList}
            itemStyle={Layout.filterInputStyle}
            onStudentSelect={(studentId) => {
              form.setFieldsValue({ enrollment: undefined });
              searchDetail({});
              feedbackDataSource([]);
              fetchEnrollCourseList(studentId);
            }}
          />
          <EnrollCourseFormItem
            fetchEnrollCourseList={fetchEnrollCourseList}
            fetchEnrollCourseDetail={fetchEnrollCourseDetail}
            enrollCourseList={enrollCourseList}
            form={form}
            showLessonCount={true}
          />
          <ShowUserDetail
            label={text.balance}
            displayDetail={enrollCourseDetail}
            displayData='balance'
            prefix='AUD'
          />
          <TeacherFormItem
            label='上课老师'
            form={form}
            teacherList={teacherList}
            fetchTeacherList={fetchTeacherList}
          />
          <CourseTypeSingleFormItem />
          <InputTextArea
            label={text.content}
            fieldName='content'
            placeholder={text.contentPlaceholder}
            requireMessage={text.contentRequired}
            rows={5}
            maxRows={5}
          />
          <DateFormItem />
          <SubmitFormItem hasModel={false} handleClick={handleSubmit} />
        </Form>
      </Card>
    </div>
  );
};

export default Feedback;
